export default __webpack_public_path__ + "0167ce25e6713d90ca63743993c3fa06.svg";